import React, { useState } from "react";

export default function ProjectsTabsSection() {
    const tabs = [
        {
            key: "p1",
            label: "Project 1",
            heading: "Building intelligence into your business",
            text: "Texts a lot of text about the project talking about this and that what AI can do this and that. Add your real content here.",
            imageUrl: "/images/project-1.jpg",
        },
        {
            key: "p2",
            label: "Project 2",
            heading: "Transforming operations with AI",
            text: "OSLO Labs is an AI-native technology company that designs, builds, and ships intelligent systems for businesses ready to move faster. We combine deep technical expertise with product thinking to deliver working solutions, not presentations.",
            imageUrl: "/images/project-2.jpg",
        },
        {
            key: "p3",
            label: "Project 3",
            heading: "Scaling with automation",
            text: "OSLO Labs is an AI-native technology company that designs, builds, and ships intelligent systems for businesses ready to move faster. We combine deep technical expertise with product thinking to deliver working solutions, not presentations.",
            imageUrl: "/images/project-3.jpg",
        },
        {
            key: "p4",
            label: "Project 4",
            heading: "Smart analytics integration",
            text: "OSLO Labs is an AI-native technology company that designs, builds, and ships intelligent systems for businesses ready to move faster. We combine deep technical expertise with product thinking to deliver working solutions, not presentations.",
            imageUrl: "/images/project-4.jpg",
        },
    ];

    const [activeKey, setActiveKey] = useState(tabs[0].key);
    const activeTab = tabs.find((t) => t.key === activeKey);

    return (
        <section style={{ paddingTop: 50, paddingBottom: 40 }}>
            <div className="container">

                {/* Tabs - SAME POSITION AS BEFORE */}
                <div
                    className="d-inline-flex align-items-center p-2 rounded-pill border bg-light"
                    style={{ gap: 8 }}
                >
                    <ul className="nav nav-pills m-0" style={{ gap: 8 }}>
                        {tabs.map((tab) => {
                            const isActive = tab.key === activeKey;

                            return (
                                <li className="nav-item" key={tab.key}>
                                    <button
                                        type="button"
                                        className={[
                                            "nav-link rounded-pill px-4",
                                            isActive
                                                ? "active bg-white text-dark shadow-sm"
                                                : "text-secondary",
                                        ].join(" ")}
                                        onClick={() => setActiveKey(tab.key)}
                                        style={{
                                            border: isActive
                                                ? "1px solid rgba(0,0,0,0.08)"
                                                : "1px solid transparent",
                                            minWidth: 130,
                                        }}
                                    >
                                        {tab.label}
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>

                {/* Content Section */}
                <div className="row align-items-center g-4 mt-4">

                    {/* LEFT SIDE - TEXT */}
                    <div className="col-md-6">
                        <h2 className="fw-bold mb-3">
                            {activeTab.heading}
                        </h2>
                        <p className="text-secondary" style={{ lineHeight: 1.8 }}>
                            {activeTab.text}
                        </p>
                    </div>

                    {/* RIGHT SIDE - IMAGE CONTAINER */}
                    <div className="col-md-6">
                        <div
                            className="w-100 bg-light overflow-hidden"
                            style={{
                                borderRadius: "10px",
                                height: "360px",
                                backgroundImage: `url(${activeTab.imageUrl})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        />
                    </div>

                </div>
            </div>
        </section>
    );
}